import React from 'react';
import Select, { Props as ReactSelectProps } from 'react-select';

interface StyledReactSelectProps extends ReactSelectProps {
  error?: boolean;
}

const ReactSelect = React.forwardRef<any, StyledReactSelectProps>(
  ({ error, ...props }, ref) => (
    <Select
      {...props}
      ref={ref}
      styles={{
        control: (styles, state) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          fontSize: '14px',
          borderColor: error ? '#f04438' : '#d0d5dd',
          borderWidth: '1px',
          borderRadius: '10px',
          color: '#333',
          padding: '0',
          backgroundColor: state.isDisabled ? '#f9fafb' : '#fff',
          ':focus-within': {
            border: '1px solid #2479BF',
            boxShadow: '0 0 0 3px rgba(96, 60, 255, 0.07)',
          },
        }),
        input: (styles) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          transition: '0.3s all',
          fontSize: '14px',
          '@media (min-width: 1340px)': {
            padding: '10px 0',
          },
          '@media (max-width: 1340px)': {
            padding: '6px 0',
          },
        }),
        placeholder: (styles) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          fontSize: '14px',
        }),
        singleValue: (styles) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          fontSize: '14px',
        }),
        noOptionsMessage: (styles) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          fontSize: '14px',
        }),
        menu: (styles) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          fontSize: '14px',
          border: '1px solid #eaecf0',
          borderRadius: '8px',
          backgroundColor: 'white',
          boxShadow: '0 12px 16px -4px #1018283a',
        }),
        option: (styles, state) => ({
          ...styles,
          fontFamily: 'Inter-Regular',
          fontSize: '14px',
          backgroundColor: state.isSelected ? '#2479BF' : 'white',
          ':hover': {
            backgroundColor: '#f9fafb',
            color: '#2479BF',
            cursor: 'pointer',
          },
        }),
        multiValue: (styles) => ({
          ...styles,
          borderRadius: '8px',
        }),
        multiValueLabel: (styles) => ({
          ...styles,
          borderRadius: '8px',
        }),
        multiValueRemove: (styles) => ({
          ...styles,
          borderRadius: '8px',
        }),
      }}
    />
  )
);

export default ReactSelect;
